export const Source = {
    web: 'web',
    scholar: 'scholar',
    edgar: 'edgar', // deprecated
    wiley: 'wiley', // deprecated
    org: 'org',
    my_files: 'my_files',
    crunchbase: 'crunchbase',
    factset: 'factset',
    google_drive: 'google_drive',
    onedrive: 'onedrive',
    sharepoint: 'sharepoint',
    dropbox: 'dropbox',
    box: 'box',
    notion_mcp: 'notion_mcp',
    outlook: 'outlook',
    linear: 'linear',
    linear_alt: 'linear_alt',
    slack: 'slack',
    github_mcp_direct: 'github_mcp_direct',
    github_delegate_bot: 'github_delegate_bot',
    asana_mcp_direct: 'asana_mcp_direct',
    asana_mcp_merge: 'asana_mcp_merge',
    atlassian_mcp_direct: 'atlassian_mcp_direct',
    slack_direct: 'slack_direct',
    jira_mcp_merge: 'jira_mcp_merge',
    confluence_mcp_merge: 'confluence_mcp_merge',
    microsoft_teams_mcp_merge: 'microsoft_teams_mcp_merge',
    wiley_mcp_cashmere: 'wiley_mcp_cashmere',
    cbinsights_mcp_cashmere: 'cbinsights_mcp_cashmere',
    pitchbook_mcp_cashmere: 'pitchbook_mcp_cashmere',
    statista_mcp_cashmere: 'statista_mcp_cashmere',
    space: 'space',
    gcal: 'gcal',
    sports: 'sports',
    zoom: 'zoom',
    apple_healthkit: 'apple_healthkit',
    medical_records: 'medical_records',
    wearables: 'wearables',
    google_docs: 'google_docs',
    finance_agent: 'finance_agent',
    plaid: 'plaid',
    openrouter: 'openrouter',
    health: 'health',
    function_health: 'function_health',
    midpage: 'midpage',
    visualdx: 'visualdx',
    nejm: 'nejm',
    bmj: 'bmj',
};
const ALLOWED_SOURCES = Object.values(Source).filter((source) => source !== 'wiley' && source !== 'edgar');
export const isSourceType = (value) => {
    return ALLOWED_SOURCES.includes(value);
};
export const asSourceTypes = (value) => {
    if (!Array.isArray(value)) {
        return [];
    }
    return value.filter(isSourceType);
};
/**
 * @deprecated Check `source.is_premium` from the API response instead.
 * Kept only for callers that don't have the source object available.
 */
//# sourceMappingURL=SourcesConfig.js.map